// sidebarMenu
const $ded555b9b8010523$export$cdfcf243c1702a55 = [
    {
        title: "Home",
        icon: '<i class="ri-home-4-line"></i>'
    },
    {
        title: "Explore",
        icon: '<i class="ri-compass-3-line"></i>'
    },
    {
        title: "Shorts",
        icon: '<i class="ri-movie-line"></i>'
    },
    {
        title: "Subscription",
        icon: '<i class="ri-add-box-line"></i>'
    }
];
const $ded555b9b8010523$export$cd68ce1c87e4b7e6 = [
    {
        title: "History",
        icon: '<i class="ri-history-line"></i>'
    },
    {
        title: "Watch Later",
        icon: '<i class="ri-timer-2-line"></i>'
    },
    {
        title: "PlayLists",
        icon: '<i class="ri-play-circle-line"></i>'
    },
    {
        title: "Liked Videos",
        icon: '<i class="ri-heart-3-line"></i>'
    }
];
const $ded555b9b8010523$export$2764082edd64fe4d = [
    {
        title: "Notifications",
        icon: '<i class="ri-notification-4-line"></i>'
    },
    {
        title: "Settings",
        icon: '<i class="ri-settings-4-line"></i>'
    },
    {
        title: "Logout",
        icon: '<i class="ri-logout-box-r-line"></i>'
    }
];
const $ded555b9b8010523$export$b6d5cde5b95a3257 = [
    {
        title: ""
    },
    {
        title: "Library"
    },
    {
        title: "Settings"
    }
];


const $d6d7f70929d7bdcf$var$sidebarMenu = document.querySelector(".sidebarMenu");
let $d6d7f70929d7bdcf$var$homeHTML = "", $d6d7f70929d7bdcf$var$generalHTML = "", $d6d7f70929d7bdcf$var$libraryHTML = "";
(0, $ded555b9b8010523$export$cdfcf243c1702a55).forEach((item)=>{
    $d6d7f70929d7bdcf$var$homeHTML += `
        <li class="sidebar__item">
            ${item.icon}
            <h3 class="sidebar__item-title">${item.title}</h3>
        </li>
    `;
});
(0, $ded555b9b8010523$export$cd68ce1c87e4b7e6).forEach((item)=>{
    $d6d7f70929d7bdcf$var$libraryHTML += `
        <li class="sidebar__item">
            ${item.icon}
            <h3 class="sidebar__item-title">${item.title}</h3>
        </li>
    `;
});
(0, $ded555b9b8010523$export$2764082edd64fe4d).forEach((item)=>{
    $d6d7f70929d7bdcf$var$generalHTML += `
        <li class="sidebar__item">
            ${item.icon}
            <h3 class="sidebar__item-title">${item.title}</h3>
        </li>
    `;
});
const $d6d7f70929d7bdcf$var$youtubesidebarHTML = [
    $d6d7f70929d7bdcf$var$homeHTML,
    $d6d7f70929d7bdcf$var$libraryHTML,
    $d6d7f70929d7bdcf$var$generalHTML
];
(0, $ded555b9b8010523$export$b6d5cde5b95a3257).forEach((item, index)=>{
    item.HTML = $d6d7f70929d7bdcf$var$youtubesidebarHTML[index];
});
console.log((0, $ded555b9b8010523$export$b6d5cde5b95a3257));
let $d6d7f70929d7bdcf$var$HTML = "";
(0, $ded555b9b8010523$export$b6d5cde5b95a3257).forEach((item)=>{
    $d6d7f70929d7bdcf$var$HTML += `
    
    <div class="sidebar__menu">
                <h2 class="sidebar__title">${item.title}</h2>
                <ul class="sidebar__list">
                    ${item.HTML}
                </ul>
            </div>
    `;
});
document.querySelector(".sidebar__menu-all").innerHTML = $d6d7f70929d7bdcf$var$HTML;
//sidebar show
const $d6d7f70929d7bdcf$var$sidebar = document.getElementById("sidebar"), $d6d7f70929d7bdcf$var$sidebarToggle = document.getElementById("sidebar-toggle");
if ($d6d7f70929d7bdcf$var$sidebar && $d6d7f70929d7bdcf$var$sidebarToggle) $d6d7f70929d7bdcf$var$sidebarToggle.addEventListener("click", ()=>{
    $d6d7f70929d7bdcf$var$sidebar.classList.toggle("sidebar-show");
});
// LinkActive
const $d6d7f70929d7bdcf$var$sidebarLink = document.querySelectorAll(".sidebar__item");
function $d6d7f70929d7bdcf$var$activeLink() {
    $d6d7f70929d7bdcf$var$sidebarLink.forEach((item)=>item.classList.remove("active"));
    this.classList.add("active");
}
$d6d7f70929d7bdcf$var$sidebarLink.forEach((item)=>item.addEventListener("click", $d6d7f70929d7bdcf$var$activeLink));


//# sourceMappingURL=youtubeSideBar.578f08ca.js.map
